import type { ProfileBaseInfo } from '@/modules/profile/types/profile'
import { ProfileApi } from '@/modules/profile/api/profileApi'
import { i18n } from '@/i18n'

const normalizePhoto = (photo: string | null): string | null => {
  if (!photo) {
    return null
  }

  if (photo.startsWith('http://') || photo.startsWith('https://')) {
    return photo
  }

  if (photo.startsWith('//')) {
    return `${window.location.protocol}${photo}`
  }

  return photo
}

export const loadProfileBaseInfo = async (token?: string): Promise<ProfileBaseInfo> => {
  const response = token === undefined ? await ProfileApi.getBaseInfo() : await ProfileApi.getBaseInfo(token)

  if (response.result !== 'success') {
    const err = new Error(i18n.global.t('errors.profileLoadFailed')) as Error & { errorCode?: number }
    err.errorCode = (response as any).error_code
    throw err
  }

  const reflink = response.data.reflink ?? response.data.referral_link ?? response.data.referal_link ?? null

  return {
    ...response.data,
    photo: normalizePhoto(response.data.photo),
    reflink,
    referral_link: response.data.referral_link ?? reflink,
    referal_link: response.data.referal_link ?? reflink,
  }
}
